import React from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight } from 'lucide-react';
export function SpeakerProfiles() {
  const criteria = ['A recognised expert with a track record of transformation', 'Clear on the outcome their talk is designed to drive', 'Trusted by leadership teams, HR, and public sector clients', 'Known for energy, clarity, depth – and safe, powerful delivery'];
  return <section className="py-24 bg-cream-100" data-id="element-103">
      <div className="max-w-7xl mx-auto px-6" data-id="element-104">
        <div className="bg-white rounded-2xl shadow-sm overflow-hidden flex flex-col lg:flex-row" data-id="element-105">
          {/* Content Side */}
          <div className="lg:w-1/2 p-8 md:p-12 lg:p-16 flex flex-col justify-center" data-id="element-106">
            <h2 className="text-3xl md:text-4xl font-heading text-navy-900 mb-6" data-id="element-107">
              Speaker Profiles
            </h2>

            <p className="text-lg font-medium text-navy-800 mb-6" data-id="element-108">
              Each Goldspeaker is:
            </p>

            <ul className="space-y-4 mb-10" data-id="element-109">
              {criteria.map((item, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex items-start gap-3" data-id="element-110">
                  <div className="mt-1 w-5 h-5 rounded-full bg-gold-100 flex items-center justify-center flex-shrink-0" data-id="element-111">
                    <Check size={12} className="text-gold-500" data-id="element-112" />
                  </div>
                  <span className="text-gray-700" data-id="element-113">{item}</span>
                </motion.li>)}
            </ul>

            <div className="p-4 bg-cream-50 rounded-lg border-l-4 border-gold-500 mb-8" data-id="element-114">
              <p className="font-heading text-xl text-navy-900" data-id="element-115">
                Our Speakers Don't Just Inspire. They Move Organizations.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-116">
              <button className="bg-navy-900 hover:bg-navy-800 text-white px-6 py-3 rounded-lg font-semibold text-sm transition-colors flex items-center justify-center gap-2" data-id="element-117">
                See Example Profiles <ArrowRight size={16} data-id="element-118" />
              </button>
              <button className="bg-transparent border-2 border-navy-900 text-navy-900 hover:bg-navy-50 px-6 py-3 rounded-lg font-semibold text-sm transition-colors flex items-center justify-center gap-2" data-id="element-119">
                Request Custom Shortlist <ArrowRight size={16} data-id="element-120" />
              </button>
            </div>
          </div>

          {/* Image Side */}
          <div className="lg:w-1/2 bg-gray-200 min-h-[400px] relative" data-id="element-121">
            {/* Placeholder for speaker image */}
            <div className="absolute inset-0 bg-gradient-to-br from-petrol-600/20 to-navy-900/20 mix-blend-multiply" data-id="element-122"></div>
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-123">
              <div className="text-center p-8" data-id="element-124">
                <div className="w-24 h-24 bg-white/30 backdrop-blur-md rounded-full mx-auto mb-4 flex items-center justify-center" data-id="element-125">
                  <UsersIcon className="text-white w-10 h-10" data-id="element-126" />
                </div>
                <p className="text-white/80 font-medium" data-id="element-127">
                  Professional Speaker Network
                </p>
              </div>
            </div>
            {/* We don't have the real image, so using a colored placeholder that fits the theme */}
            <div className="w-full h-full bg-navy-800/10" data-id="element-128"></div>
          </div>
        </div>
      </div>
    </section>;
}
function UsersIcon({
  className
}: {
  className?: string;
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-129">
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" data-id="element-130" />
      <circle cx="9" cy="7" r="4" data-id="element-131" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" data-id="element-132" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" data-id="element-133" />
    </svg>;
}